<template>
  <span>
    <span v-if="$apollo.queries.queriedPerson.loading">
      <v-progress-circular active indeterminate size="16" color="muted" />
    </span>
    <span v-else-if="!person"> - </span>
    <span v-else-if="noLink">
      {{ displayName }}
    </span>
    <router-link
      v-else
      :to="{
        name: 'PersonProfilePage',
        params: { personId: displayPerson.id }
      }"
      :target="linkTarget"
      class="no-default-link-style"
      >{{ displayName }}<slot name="appendPersonName" :person="person"
    /></router-link>
    <slot name="personNameAdditionalDetails" :person="person" />
  </span>
</template>
<script>
import gql from "fraql";
import { getFederationConfiguration } from "@composables/masterdata/config";
export default {
  name: "AppShowPersonName",
  props: {
    person: {
      type: [Object, String],
      default: null
    },
    noLink: {
      type: Boolean,
      default: false
    },
    linkTarget: {
      type: String,
      default: undefined
    }
  },
  setup() {
    return {
      ...getFederationConfiguration()
    };
  },
  computed: {
    displayPerson() {
      if (typeof this.person === "string" || this.person instanceof String) {
        return this.queriedPerson || { id: this.person };
      } else {
        return this.person;
      }
    },
    displayName() {
      return this.displayPerson.name;
    }
  },
  fragments: {
    person: gql`
      fragment _ on Person {
        id
        name
        firstName
        lastName
      }
    `
  },
  apollo: {
    queriedPerson: {
      query: gql`
        query showPersonName($id: ID) {
          person(id: $id) {
            id
            name
            firstName
            lastName
          }
        }
      `,
      variables() {
        return {
          id: this.person
        };
      },
      skip() {
        // Skip if given prop is not string
        return !(
          typeof this.person === "string" || this.person instanceof String
        );
      },
      update: ({ person }) => person,
      fetchPolicy: "cache-first"
    }
  }
};
</script>
